import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import List from './list-item';
import {TrackSelection} from './index';

export default function Submenu(props) {
  const {options, ...rest} = props;
  let {ids} = props;
  const {selected} = React.useContext(TrackSelection);
  const initialValueIndex = getSelectedValueIndex();
  const [activeIndex, setActiveIndex] = React.useState(initialValueIndex !== -1 ? initialValueIndex : null);

  if (!ids) {
    ids = [];
  }

  function getSelectedValueIndex() {
    return options.indexOf(options.find(data => selected.indexOf(data.id) !== -1));
  }

  const handleActive = (event, index) => {
    event.stopPropagation();
    if (activeIndex === index) {
      index = null;
    }
    setActiveIndex(index);
  };

  return (
    <ul className={classnames('dropdown-menu')} {...rest}>
      {Boolean(options) &&
        options.map((data, index) => (
          <List
            key={index}
            data={data}
            activeIndex={activeIndex}
            index={index}
            ids={ids.slice()}
            onClick={handleActive}
          />
        ))}
    </ul>
  );
}

Submenu.defaultProps = {};

Submenu.propTypes = {
  /** An array passed to the component for dropdown submenu */
  options: PropTypes.array,
  /** Selected ids of list item */
  ids: PropTypes.array,
};
